export const EQUIPE_SALVAR = 'EQUIPE_SALVAR'
export const EQUIPE_SALVAR_SUCCESS = 'EQUIPE_SALVAR_SUCCESS'

export const EQUIPE_REMOVER = 'EQUIPE_REMOVER'
export const EQUIPE_REMOVER_SUCCESS = 'EQUIPE_REMOVER_SUCCESS'